import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  PlusCircle,
  Calendar,
  MapPinned,
  Car,
  Bell,
  Search,
  ChevronLeft,
  ChevronRight,
  Mail,
  Settings,
} from 'lucide-react';
import '../App.css';
import './UiPrototype.css';

const TABS = [
  { id: 'dashboard', label: 'Табло', icon: LayoutDashboard },
  { id: 'carpool', label: 'Карпул', icon: Users },
  { id: 'create', label: 'Нов карпул', icon: PlusCircle },
  { id: 'schedule', label: 'График', icon: Calendar },
  { id: 'tracking', label: 'Проследяване', icon: MapPinned },
];

const PAGE_TITLES = {
  dashboard: 'Табло',
  carpool: 'Училище „Св. Климент“',
  create: 'Нов карпул',
  schedule: 'График на пътуванията',
  tracking: 'Проследяване',
};

function UiPrototype() {
  const [active, setActive] = useState('dashboard');

  return (
    <div className="ui-prototype">
      <div className="ui-prototype__banner">
        <span>
          Статичен преглед — без вход. Показани са основни екрани за визуален ориентир, не цялата
          функционалност на продукта.
        </span>
        <Link to="/login">Към вход</Link>
      </div>

      <div className="ui-prototype__shell">
        <aside className="ui-prototype__sidebar" aria-label="Примерна навигация">
          <div className="ui-prototype__logo">GoKid</div>
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = active === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                className={`ui-prototype__nav-item${isActive ? ' is-active' : ''}`}
                onClick={() => setActive(tab.id)}
              >
                <Icon size={18} strokeWidth={2} />
                {tab.label}
              </button>
            );
          })}
          <div className="ui-prototype__sidebar-footer">
            <Users size={14} aria-hidden />
            <span>Мария И.</span>
          </div>
        </aside>

        <div className="ui-prototype__workspace">
          <header className="ui-prototype__chrome">
            <div className="ui-prototype__chrome-title">
              <span className="ui-prototype__chrome-breadcrumb">Приложение</span>
              <span className="ui-prototype__chrome-page">{PAGE_TITLES[active]}</span>
            </div>
            <div className="ui-prototype__chrome-search" role="search">
              <Search size={16} strokeWidth={2} aria-hidden />
              <input type="search" placeholder="Търсене в карпули, деца…" readOnly tabIndex={-1} />
            </div>
            <div className="ui-prototype__chrome-actions">
              <button type="button" className="ui-prototype__icon-btn" aria-label="Известия">
                <Bell size={20} strokeWidth={2} />
                <span className="ui-prototype__badge" aria-hidden />
              </button>
              <div className="ui-prototype__avatar" title="Профил">
                МИ
              </div>
            </div>
          </header>

          <main className="ui-prototype__main">
          {active === 'dashboard' && (
            <>
              <h1 className="ui-prototype__title">Здравейте</h1>
              <p className="ui-prototype__subtitle">
                Преглед на предстоящи пътувания и вашите групи.
              </p>
              <div className="ui-prototype__grid-stats">
                <div className="ui-prototype__stat">
                  <div className="ui-prototype__stat-value">3</div>
                  <div className="ui-prototype__stat-label">Активни карпули</div>
                </div>
                <div className="ui-prototype__stat">
                  <div className="ui-prototype__stat-value">2</div>
                  <div className="ui-prototype__stat-label">Пътувания тази седмица</div>
                </div>
                <div className="ui-prototype__stat">
                  <div className="ui-prototype__stat-value">5</div>
                  <div className="ui-prototype__stat-label">Деца в профила</div>
                </div>
              </div>
              <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>Вашите карпули</h2>
              <div className="ui-prototype__cards">
                <div className="ui-prototype__card">
                  <div>
                    <h3>Училище „Св. Климент“</h3>
                    <div className="ui-prototype__card-meta">
                      Пон–Пет · Сутрешно взимане · 4 родители
                    </div>
                  </div>
                  <span className="ui-prototype__pill">Активен</span>
                </div>
                <div className="ui-prototype__card">
                  <div>
                    <h3>Футболен тренировки</h3>
                    <div className="ui-prototype__card-meta">
                      Вт, Чт · Следобед · 3 родители
                    </div>
                  </div>
                  <span className="ui-prototype__pill">Активен</span>
                </div>
              </div>
            </>
          )}

          {active === 'carpool' && (
            <>
              <p className="ui-prototype__subtitle" style={{ marginTop: -8 }}>
                Екран с детайли за една група — членове, покани, бързи действия (пример).
              </p>
              <div className="ui-prototype__detail-hero">
                <div>
                  <h1 className="ui-prototype__title" style={{ marginBottom: 4 }}>
                    Училище „Св. Климент“
                  </h1>
                  <p className="ui-prototype__detail-meta">
                    Сутрешно взимане · Пон–Пет · 4 родители · 6 деца
                  </p>
                </div>
                <div className="ui-prototype__detail-actions">
                  <button type="button" className="btn-secondary">
                    <Mail size={16} /> Покана
                  </button>
                  <button type="button" className="btn-primary">
                    <Calendar size={16} /> График
                  </button>
                </div>
              </div>
              <div className="ui-prototype__detail-grid">
                <section className="ui-prototype__panel">
                  <h2 className="ui-prototype__panel-title">Родители</h2>
                  <ul className="ui-prototype__member-list">
                    <li>
                      <span className="ui-prototype__avatar sm">МИ</span>
                      <div>
                        <strong>Мария Иванова</strong>
                        <span>Организатор · вие</span>
                      </div>
                    </li>
                    <li>
                      <span className="ui-prototype__avatar sm">ИП</span>
                      <div>
                        <strong>Иван Петров</strong>
                        <span>Член</span>
                      </div>
                    </li>
                    <li>
                      <span className="ui-prototype__avatar sm">ГС</span>
                      <div>
                        <strong>Гергана Стоянова</strong>
                        <span>Член</span>
                      </div>
                    </li>
                  </ul>
                </section>
                <section className="ui-prototype__panel">
                  <h2 className="ui-prototype__panel-title">Деца в този карпул</h2>
                  <p className="ui-prototype__panel-note">
                    Алекс И., Михаил П., Елена С., … (примерни имена)
                  </p>
                  <button type="button" className="btn-ghost">
                    <Settings size={16} /> Управление на деца (реалното приложение)
                  </button>
                </section>
              </div>
            </>
          )}

          {active === 'create' && (
            <>
              <h1 className="ui-prototype__title">Нов карпул</h1>
              <p className="ui-prototype__subtitle">Създаване в няколко стъпки (пример).</p>
              <div className="ui-prototype__steps">
                <span className="ui-prototype__step is-current">1. Детайли</span>
                <span className="ui-prototype__step">2. Маршрут</span>
                <span className="ui-prototype__step">3. График</span>
              </div>
              <div className="ui-prototype__form-row">
                <label htmlFor="p-name">Име на групата</label>
                <input
                  id="p-name"
                  className="ui-prototype__input"
                  type="text"
                  defaultValue="Карпул до училище"
                  readOnly
                />
              </div>
              <div className="ui-prototype__form-row">
                <label htmlFor="p-desc">Бележки (по желание)</label>
                <input
                  id="p-desc"
                  className="ui-prototype__input"
                  type="text"
                  placeholder="Напр. вратата за кратък престой"
                  readOnly
                />
              </div>
              <div className="ui-prototype__form-row">
                <label>Карта (място за избор на адреси)</label>
                <div className="ui-prototype__map">Примерна карта — интеграция с карти в реалното приложение</div>
              </div>
              <button type="button" className="btn-primary" style={{ marginTop: 8 }}>
                Напред
              </button>
            </>
          )}

          {active === 'schedule' && (
            <>
              <p className="ui-prototype__subtitle" style={{ marginTop: -8 }}>
                Седмична матрица + детайли по дни. Реалният график идва от сървъра; тук е само
                оформление.
              </p>

              <div className="ui-prototype__schedule-toolbar">
                <label className="ui-prototype__select-wrap">
                  <span className="ui-prototype__sr-only">Карпул</span>
                  <select className="ui-prototype__select" defaultValue="school" aria-label="Карпул">
                    <option value="school">Училище „Св. Климент“</option>
                    <option value="football">Футболни тренировки</option>
                  </select>
                </label>
                <div className="ui-prototype__week-nav">
                  <button type="button" className="ui-prototype__icon-btn light" aria-label="Предишна седмица">
                    <ChevronLeft size={18} />
                  </button>
                  <span className="ui-prototype__week-label">17 – 23 март 2025</span>
                  <button type="button" className="ui-prototype__icon-btn light" aria-label="Следваща седмица">
                    <ChevronRight size={18} />
                  </button>
                </div>
                <div className="ui-prototype__view-toggle">
                  <button type="button" className="is-active">
                    Седмица
                  </button>
                  <button type="button">
                    Списък
                  </button>
                </div>
              </div>

              <div className="ui-prototype__legend">
                <span>
                  <i className="ui-prototype__legend-swatch you" /> Вие шофирате
                </span>
                <span>
                  <i className="ui-prototype__legend-swatch other" /> Друг родител
                </span>
                <span>
                  <i className="ui-prototype__legend-swatch maybe" /> Не сте определени
                </span>
                <span>
                  <i className="ui-prototype__legend-swatch empty" /> Няма пътуване
                </span>
              </div>

              <div className="ui-prototype__schedule">
                <div className="ui-prototype__schedule-head">
                  <span className="ui-prototype__schedule-corner">Час / ден</span>
                  <span>
                    Пон <small>17</small>
                  </span>
                  <span>
                    Вто <small>18</small>
                  </span>
                  <span>
                    Сря <small>19</small>
                  </span>
                  <span>
                    Чет <small>20</small>
                  </span>
                  <span>
                    Пет <small>21</small>
                  </span>
                </div>
                <div className="ui-prototype__schedule-row">
                  <div className="ui-prototype__schedule-time">
                    07:30
                    <small>Към училище</small>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot you" title="Вие карате">
                      <span className="ui-prototype__slot-initials">МИ</span>
                      <small>Вие</small>
                    </div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot other">
                      <span className="ui-prototype__slot-initials">ИП</span>
                      <small>Иван П.</small>
                    </div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot you">
                      <span className="ui-prototype__slot-initials">МИ</span>
                      <small>Вие</small>
                    </div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot other">
                      <span className="ui-prototype__slot-initials">ГС</span>
                      <small>Гергана</small>
                    </div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot you">
                      <span className="ui-prototype__slot-initials">МИ</span>
                      <small>Вие</small>
                    </div>
                  </div>
                </div>
                <div className="ui-prototype__schedule-row">
                  <div className="ui-prototype__schedule-time">
                    15:10
                    <small>От училище</small>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot other">
                      <span className="ui-prototype__slot-initials">ИП</span>
                      <small>Иван П.</small>
                    </div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot maybe">?</div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot other">
                      <span className="ui-prototype__slot-initials">ГС</span>
                      <small>Гергана</small>
                    </div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot empty">—</div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot other">
                      <span className="ui-prototype__slot-initials">ИП</span>
                      <small>Иван П.</small>
                    </div>
                  </div>
                </div>
                <div className="ui-prototype__schedule-row">
                  <div className="ui-prototype__schedule-time">
                    17:00
                    <small>Допълнително</small>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot empty">—</div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot empty">—</div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot empty">—</div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot maybe">?</div>
                  </div>
                  <div className="ui-prototype__schedule-cell">
                    <div className="ui-prototype__slot empty">—</div>
                  </div>
                </div>
              </div>

              <h2 className="ui-prototype__section-heading">Детайли по дни</h2>
              <ul className="ui-prototype__day-details">
                <li>
                  <div className="ui-prototype__day-label">
                    <strong>Понеделник, 17 март</strong>
                    <span>2 пътувания</span>
                  </div>
                  <div className="ui-prototype__day-rides">
                    <div className="ui-prototype__ride-chip">
                      <span>07:30</span> Към училище · <strong>Вие</strong> · Алекс, Михаил
                    </div>
                    <div className="ui-prototype__ride-chip muted">
                      <span>15:10</span> От училище · <strong>Иван П.</strong> · три деца
                    </div>
                  </div>
                </li>
                <li>
                  <div className="ui-prototype__day-label">
                    <strong>Вторник, 18 март</strong>
                    <span>2 пътувания</span>
                  </div>
                  <div className="ui-prototype__day-rides">
                    <div className="ui-prototype__ride-chip">
                      <span>07:30</span> Към училище · <strong>Иван П.</strong>
                    </div>
                    <div className="ui-prototype__ride-chip warn">
                      <span>15:10</span> От училище · <em>няма шофьор</em> — отворете за записване
                    </div>
                  </div>
                </li>
                <li>
                  <div className="ui-prototype__day-label">
                    <strong>Сряда, 19 март</strong>
                    <span>1 пътуване</span>
                  </div>
                  <div className="ui-prototype__day-rides">
                    <div className="ui-prototype__ride-chip">
                      <span>07:30</span> Към училище · <strong>Вие</strong>
                    </div>
                  </div>
                </li>
              </ul>
            </>
          )}

          {active === 'tracking' && (
            <>
              <h1 className="ui-prototype__title">Проследяване</h1>
              <p className="ui-prototype__subtitle">
                По време на пътуване — карта и статус (пример).
              </p>
              <div className="ui-prototype__track">
                <div className="ui-prototype__track-map">
                  <span>
                    <Car size={20} style={{ verticalAlign: 'middle', marginRight: 8 }} />
                    Жива позиция на картата
                  </span>
                </div>
                <div className="ui-prototype__track-panel">
                  <h4>Днешно пътуване</h4>
                  <div className="ui-prototype__track-line">
                    <span>Статус</span>
                    <strong>В движение</strong>
                  </div>
                  <div className="ui-prototype__track-line">
                    <span>Шофьор</span>
                    <strong>Иван П.</strong>
                  </div>
                  <div className="ui-prototype__track-line">
                    <span>ETA</span>
                    <strong>~8 мин</strong>
                  </div>
                </div>
              </div>
            </>
          )}
          </main>
        </div>
      </div>
    </div>
  );
}

export default UiPrototype;
